import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const sections = [
  { title: '第1条（個人情報の定義）', body: '本プライバシーポリシーにおける「個人情報」とは、個人情報保護法に定める個人情報を指し、氏名、住所、電話番号、メールアドレス等、特定の個人を識別できる情報をいいます。' },
  { title: '第2条（個人情報の収集）', body: '当社は、お問い合わせフォームその他のサービス利用時に、氏名・メールアドレス・電話番号・会社名等の個人情報をご提供いただく場合があります。' },
  { title: '第3条（個人情報の利用目的）', body: '収集した個人情報は、お問い合わせへの回答・サービス提供・ご連絡・サービス改善のためにのみ利用します。ご本人の同意なく第三者に提供することはありません。' },
  { title: '第4条（個人情報の第三者提供）', body: '当社は、法令に基づく場合を除き、ご本人の同意なく個人情報を第三者に提供いたしません。' },
  { title: '第5条（個人情報の安全管理）', body: '当社は、個人情報の漏洩・滅失・毀損を防止するため、適切な安全管理措置を講じます。' },
  { title: '第6条（個人情報の開示・訂正・削除）', body: 'ご本人から個人情報の開示・訂正・削除のご請求があった場合、合理的な期間内に対応いたします。お問い合わせ窓口までご連絡ください。' },
  { title: '第7条（Cookieの使用）', body: '当社ウェブサイトでは、サービス向上のためCookieを使用する場合があります。ブラウザの設定によりCookieを無効にすることができますが、一部機能が制限される場合があります。' },
  { title: '第8条（プライバシーポリシーの変更）', body: '当社は、必要に応じて本プライバシーポリシーを変更することがあります。変更後のポリシーは本ページに掲載した時点で効力を生じます。' },
  { title: '第9条（お問い合わせ）', body: '個人情報の取り扱いに関するお問い合わせは、下記までご連絡ください。\n株式会社Ocean\n代表者：小西 真平\n所在地：〒530-0043 大阪府大阪市北区天満１丁目４−１９ キオプラザ天満橋\nメール：banking@oceansubstitute.com\n電話：080-4480-0273' },
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-teal-900 to-cyan-800 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img src="https://readdy.ai/api/search-image?query=abstract%20turquoise%20ocean%20wave%20pattern%20digital%20technology%20background%20minimal%20clean%20teal%20cyan%20gradient%20with%20geometric%20shapes&width=1920&height=400&seq=ocean-privacy-hero-01&orientation=landscape" alt="" className="w-full h-full object-cover object-top" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
          <p className="text-teal-200 text-xs font-semibold uppercase tracking-widest mb-3">Privacy Policy</p>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>プライバシーポリシー</h1>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <p className="text-sm text-gray-600 leading-relaxed mb-8">株式会社Ocean（以下「当社」）は、お客様の個人情報の保護を重要な責務と考え、以下のプライバシーポリシーを定めます。</p>
          <div className="space-y-6">
            {sections.map((s) => (
              <div key={s.title} className="border-l-2 border-teal-300 pl-5">
                <h4 className="text-sm font-bold text-gray-900 mb-2">{s.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed whitespace-pre-line">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
